import React from "react";
import { FaHeart, FaInfoCircle, FaRegHeart, FaVideo } from "react-icons/fa";

import {
  DEFAULT_TECHNIQUE_IMAGE,
  getCeintureBadgeClass,
  getTechniqueUv2List,
} from "../utils/techniquesRevisionUtils";

function TechniqueCard({
  technique,
  isFavorite = false,
  favoritesLoading = false,
  onOpen,
  onToggleFavorite,
}) {
  const uv2List = getTechniqueUv2List(technique);

  return (
    <article className="group overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-xl shadow-slate-200/60 transition hover:-translate-y-1 hover:shadow-2xl dark:border-white/10 dark:bg-white/[0.05] dark:shadow-black/20">
      <button
        type="button"
        onClick={onOpen}
        className="block w-full bg-slate-100 p-3 dark:bg-slate-950"
      >
        <div className="aspect-[3/4] w-full overflow-hidden rounded-[1.5rem] bg-white dark:bg-white/[0.03]">
          <img
            src={technique?.image1_url || DEFAULT_TECHNIQUE_IMAGE}
            alt={technique?.nom || "Technique"}
            className="h-full w-full object-contain transition duration-700 group-hover:scale-[1.03]"
            onError={(event) => {
              event.currentTarget.src = DEFAULT_TECHNIQUE_IMAGE;
            }}
          />
        </div>
      </button>

      <div className="p-5">
        <div className="flex flex-wrap gap-2">
          {technique?.ceinture && (
            <span
              className={`rounded-full px-3 py-1 text-xs font-bold ${getCeintureBadgeClass(
                technique.ceinture,
              )}`}
            >
              {technique.ceinture}
            </span>
          )}

          {technique?.famille && (
            <span className="rounded-full bg-slate-100 px-3 py-1 text-xs font-bold text-slate-600 dark:bg-white/10 dark:text-white/60">
              {technique.famille}
            </span>
          )}

          {/* {uv2List.map((fiche) => (
            <span
              key={fiche}
              className="rounded-full bg-sky-100 px-3 py-1 text-xs font-bold text-sky-700 dark:bg-sky-500/10 dark:text-sky-200"
            >
              Fiche {fiche}
            </span>
          ))} */}
        </div>

        <h3 className="mt-4 line-clamp-2 font-titre text-2xl font-bold text-slate-950 dark:text-white">
          {technique?.nom || "Technique sans nom"}
        </h3>

        {technique?.traduction && (
          <p className="mt-1 line-clamp-2 text-sm font-medium italic text-slate-500 dark:text-white/50">
            {technique.traduction}
          </p>
        )}

        <div className="mt-5 grid gap-2 sm:grid-cols-2">
          <button
            type="button"
            onClick={onOpen}
            className="inline-flex min-h-11 items-center justify-center gap-2 rounded-2xl bg-sky-600 px-4 py-2 text-xs font-bold text-white transition hover:-translate-y-0.5"
          >
            <FaInfoCircle />
            Détails
          </button>

          <button
            type="button"
            onClick={onToggleFavorite}
            disabled={favoritesLoading}
            className="inline-flex min-h-11 items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-white px-4 py-2 text-xs font-bold text-slate-700 transition hover:-translate-y-0.5 hover:border-red-200 hover:text-red-600 disabled:cursor-not-allowed disabled:opacity-60 dark:border-white/10 dark:bg-white/[0.05] dark:text-white"
          >
            {isFavorite ? <FaHeart className="text-red-500" /> : <FaRegHeart />}
            Favori
          </button>
        </div>

        {technique?.video_url && (
          <a
            href={technique.video_url}
            target="_blank"
            rel="noreferrer"
            className="mt-2 inline-flex min-h-11 w-full items-center justify-center gap-2 rounded-2xl bg-red-600 px-4 py-2 text-xs font-bold text-white transition hover:-translate-y-0.5"
          >
            <FaVideo />
            Voir la vidéo
          </a>
        )}
      </div>
    </article>
  );
}

export default TechniqueCard;